import { Bar } from "react-chartjs-2";
import { Chart } from "chart.js";

import { BaseBarChartProps } from "../types";

const BaseBarChart = ({
  data,
  height,
  customOptions = {},
  className,
  title,
}: BaseBarChartProps) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: customOptions?.indexAxis || "x",
    datasets: {
      bar: {
        categoryPercentage: 0.9,
        barPercentage: customOptions?.indexAxis === "y" ? 0.8 : 0.9,
      },
    },
    layout: {
      padding: {
        top: 40,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: true,
        anchor: function (context: { chart: Chart }) {
          const chart = context.chart;
          const isHorizontal = chart.options.indexAxis === "y";
          return isHorizontal ? "end" : "end";
        },
        align: function (context: { chart: Chart }) {
          const chart = context.chart;
          const isHorizontal = chart.options.indexAxis === "y";
          return isHorizontal ? "right" : "top";
        },
        offset: 0,
        color: "#4d5157",
        font: {
          size: 14,
          family: "Roboto",
        },
        formatter: function (
          value: number,
          context: { dataset: { order: number } },
        ) {
          return context.dataset.order === 1 ? value : "";
        },
        clip: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: function (context: { chart: Chart }) {
          const isHorizontal = context.chart.options.indexAxis === "y";
          if (isHorizontal) {
            return undefined;
          }
          return data.maxCount ? Math.ceil(data.maxCount * 1.2) : undefined;
        },
        ticks: {
          stepSize: 1,
          precision: 0,
          color: "var(--neutral-900)",
          font: {
            size: 14,
            family: "Roboto",
          },
        },
        border: {
          display: false,
          color: "#c6cedc",
          width: 1,
          dash: [5, 5],
        },
      },
      x: {
        beginAtZero: true,
        max: function (context: { chart: Chart }) {
          const isHorizontal = context.chart.options.indexAxis === "y";
          if (isHorizontal) {
            return data.maxCount ? Math.ceil(data.maxCount * 1.2) : undefined;
          }
          return undefined;
        },
        ticks: {
          stepSize: 1,
          precision: 0,
          color: "#1e1e1e",
          font: {
            size: 14,
            family: "Roboto",
          },
        },
        grid: {
          color: "#c6cedc",
          lineWidth: 1,
        },
        border: {
          display: true,
          color: "#c6cedc",
          width: 1,
          dash: [5, 5],
        },
      },
    },
    onResize: function (chart: Chart) {
      chart.update("none");
    },
  };

  return (
    <div
      style={{
        height: `${height}px`,
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}
      className={"flex flex-col " + (className ? className : "")}
    >
      <div className="body-m-medium">{title}</div>
      <div
        className="chart-container"
        style={{
          height: "calc(100% - 30px)",
          width: "100%",
          overflow: "hidden",
        }}
      >
        {/*// @ts-expect-error custom options*/}
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default BaseBarChart;
